import { EventTypes, getPageSource, track } from '@mc/track-event'

export type Location = 'value-prop' | 'quiz-result-hero'

export const trackModalViewed = ({ location }: { location: Location }) =>
  track(EventTypes.MODAL_VIEWED, {
    modal_type: 'on-call-modal',
    location,
    category: 'details',
    page_source: getPageSource(),
  })
